'use strict';

var sleeknote = sleeknote || {};

sleeknote.navigation = sleeknote.navigation || function () {

    function init() {
        // Init functions
        scrolledNav();
        mobileNavigationToggler();
        filterNav();
        tooltips();
        responsiveDemo();
    }
    
    function mobileNavigationToggler(){
        $(document).on('click', '#touch-nav-toggler-js', function(e){
            console.log('mobile Navigation clicked')
            e.preventDefault();
            if ( $(this).hasClass('active') ){
                $("#site-navigation-main-js").removeClass('active');
                $(this).removeClass('active'); 
                $.scrollLock(false);
                $('#site-head-js').css('background-color','');
                $('#site-head-js').css('border-bottom','');
            } else {
                $("#site-navigation-main-js").addClass('active');
                $(this).addClass('active');
                $.scrollLock(true);
                $('#site-head-js').css('background-color','white');
                $('#site-head-js').css('border-bottom','1px solid #EBEBEA');
            }
            
        });
    }

    function scrolledNav(){

        if ( $(document).scrollTop() >= 50 ) {
            $("#site-head-js").addClass('scrolled');
        } else {
            $("#site-head-js").removeClass('scrolled');
        }

        if ( $('#list-filter-js').length ){

            var filterContainerTop = $('#list-filter-container-js').offset().top - 96; // Height of mainnavigation

            if ( $(document).scrollTop() >= filterContainerTop ) {
                $('#list-filter-js').addClass('scrolled');
            } else {
                $('#list-filter-js').removeClass('scrolled');
            }

        } 
    }

    function filterNav(){

        $(document).on('click', '#list-filter-droptoggle-js, #cat-drop-js', function(e){

            var eThis = $('#list-filter-droptoggle-js');
            var eThisParent = eThis.parent('.list-filter-xs');

            if ( eThisParent.hasClass('active')){
                eThisParent.removeClass('active');
            } else {
                eThisParent.addClass('active');
            }
            
        });

    }

    function tooltips(){
        $(document).ready(function(){
            // tippy('.feature-table-content .tippy', {
            tippy('.tippy', {
                placement: 'right',
                animation: 'scale',
                
            });
            tippy('.tooltip', {
                animation: 'scale',
            });

        });
    }

    function responsiveDemo(){

        $(document).ready(function(){

            if( $('.block-responsive-demo').length ){ 

                $('.block-responsive-demo').each(function(){ 

                    var thisDemo = $(this),
                        thisMobileToggle = thisDemo.find('.nav-item.mobile'),
                        thisDesktopToggle = thisDemo.find('.nav-item.desktop'),
                        thisMobileImg = thisDemo.find('img.mobile'),
                        thisDesktopImg = thisDemo.find('img.desktop');


                    thisMobileToggle.on('click', function(e){
                        thisMobileImg.addClass('active');
                        thisDesktopImg.removeClass('active');
                        thisDemo.addClass('narrow');
                        $(this).addClass('active');
                        thisDesktopToggle.removeClass('active');
                    });

                    thisDesktopToggle.on('click', function(e){
                        thisDesktopImg.addClass('active');
                        thisMobileImg.removeClass('active');
                        thisDemo.removeClass('narrow');
                        $(this).addClass('active');
                        thisMobileToggle.removeClass('active');
                    });


                });
                
            };

        });

    }

    $(document).scroll(function() {

        scrolledNav();
        
    });

    return {
        init:init
    };
}();